import SwiperSlider from '../base';

const selectors = {
  sliderEl: '[data-comp-similar-vehicles-slider]',
  swiperSlide: '.swiper-slide',
};

const swiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  observer: true,
  observeParents: true,
  breakpoints: {
    // when window width is >= 1320px
    1320: {
      allowTouchMove: false,
    },
  },
};

export default class SectionSimilarVehiclesSlider extends SwiperSlider {
  static selector = selectors.sliderEl;
  constructor(containerEl) {
    super(containerEl);
    this.generalSlider = new this.Swiper(
      this.$container,
      swiperOptions,
    );
    this.addSlideChangeListener();
  }

  addSlideChangeListener() {
    this.generalSlider.on('slideChange', () => {
      window.dispatchEvent(new Event('resize'));
    });
  }
}
